import { observer } from 'mobx-react-lite';
import React, { useRef } from 'react';

import { Icon, IconArrowBigLeft, IconDelete } from '@flixbus/honeycomb-icons-react';
import { Button, Heading, Popup, PopupSection } from '@flixbus/honeycomb-react';

import CrewMemberAutoComplete from 'common/CrewMemberAutocomplete';
import CrewMemberCredentials from 'common/CrewMemberNameDrivercard';
import { manageGroupDataStore } from 'pages/Profile/components/ManageGroupDataModal/ManageGroupDataStore';
import { singleGroupStore } from 'pages/Profile/components/SingleGroupTab/SingleGroupStore';
import { groupsStore } from 'pages/Profile/GroupsStore';

import { addMembersStore } from './AddMembersStore';

import styles from './styles.module.css';

const AddMembersToGroupModal = observer(() => {
	const targetRef = useRef(null);
	const {
		isFromCreation,
		addMembersActive,
		groupId,
		currentMembersAdded,
		addMemberToGroup,
		deleteMemberFromGroup,
		resetAddMembersStep,
	} = addMembersStore;
	const isOverflowScroll = [...currentMembersAdded.values()].length > 7;
	const label = isFromCreation
		? 'You can add crew members to this group now, or save it as an empty group and add them later'
		: 'Pick the crew members you’d like to add to this group';

	const handleConfirm = () => {
		// createNewGroup('test');
		if (groupsStore.isGroupSelected) {
			singleGroupStore.addMembers([...currentMembersAdded.values()]);
		}
		resetAddMembersStep();
		groupsStore.incrementMembersCount([...currentMembersAdded.values()].length, groupId);
	};

	const handleOnSelection = (crewId) => {
		addMemberToGroup(crewId, groupId);
	};

	const handleOnDelete = (crewId) => {
		deleteMemberFromGroup(crewId, groupId);
	};

	const handleClickOutside = () => {
		resetAddMembersStep();
		manageGroupDataStore.deactivateCreationFlow();
	};

	const handleGoBackInCreation = () => {
		manageGroupDataStore.activateFromStepBack();
		resetAddMembersStep();
	};

	const renderSelectedCrewMembers = () => {
		return [...currentMembersAdded.values()].map(({ id, fullName, driverCard, loading }) => (
			<div className={styles.crewMember} key={id}>
				<CrewMemberCredentials name={fullName} number={driverCard} />
				<Button
					extraClasses={styles.crewMemberBtn}
					display="square"
					size="sm"
					onClick={() => handleOnDelete(id)}
					loading={loading}
				>
					<Icon InlineIcon={IconDelete} aria-hidden="true" size={4} />
				</Button>
			</div>
		));
	};

	return (
		<Popup
			id="group-creation"
			aria-labelledby="group-creation"
			aria-describedby="group-creation"
			active={addMembersActive}
			onOverlayClick={handleClickOutside}
			targetRef={targetRef}
			extraClasses={styles.groupCreationWrapper}
		>
			<PopupSection
				type="title"
				extraClasses={`${isFromCreation ? `${styles.headerSection}` : ''}`}
			>
				<Heading id="group-create-header" size={1} sectionHeader flushSpace>
					Add members
				</Heading>
				{isFromCreation && (
					<Button
						appearance="link"
						aria-label="Back button"
						extraClasses={styles.backBtn}
						onClick={handleGoBackInCreation}
					>
						<Icon InlineIcon={IconArrowBigLeft} />
					</Button>
				)}
			</PopupSection>

			<PopupSection
				extraClasses={`${styles.moveToFormSection} ${isOverflowScroll ? styles.scroll : ''}`}
				type="content"
				id="move-to-form"
			>
				<div style={{ marginBottom: '12px' }}>{label}</div>

				<CrewMemberAutoComplete handleSelection={handleOnSelection} />

				{renderSelectedCrewMembers()}
			</PopupSection>

			<PopupSection type="actions">
				{/* <Button onClick={resetAddMembersStep}>Cancel</Button> */}
				<Button appearance="primary" onClick={() => handleConfirm()} loading={false}>
					Finish
				</Button>
			</PopupSection>
		</Popup>
	);
});

export default AddMembersToGroupModal;
